import * as React from "react";
import { useCallback, useContext, useEffect, useState } from "react";
import styled from "styled-components";
import { PaginatedList } from "components/common";
import reexecuteSearchTypes from "views/components/widgets/reexecuteSearchTypes";
import useViewsDispatch from "views/stores/useViewsDispatch";
import useAutoRefresh from "views/hooks/useAutoRefresh";
import ErrorWidget from "views/components/widgets/ErrorWidget";
import useOnSearchExecution from "views/hooks/useOnSearchExecution";
import RenderCompletionCallback from "views/components/widgets/RenderCompletionCallback";
import InvestigationsTable from "./InvestigationsTable";
import { PAGINATION } from "../Constants";
const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  overflow: auto;
  height: 100%;
`;
const useResetPaginationOnSearchExecution = (setPagination, currentPage) => {
  const resetPagination = useCallback(() => {
    if (currentPage !== 1) {
      setPagination({ currentPage: 1, pageErrors: [] });
    }
  }, [currentPage, setPagination]);
  useOnSearchExecution(resetPagination);
};
const useHandlePageChange = (searchTypeId, setLoadingState, setPagination) => {
  const dispatch = useViewsDispatch();
  const { stopAutoRefresh } = useAutoRefresh();
  return useCallback(
    (pageNo) => {
      const searchTypePayload = {
        [searchTypeId]: {
          page: pageNo,
          per_page: PAGINATION.PER_PAGE
        }
      };
      stopAutoRefresh();
      setLoadingState(true);
      return dispatch(reexecuteSearchTypes(searchTypePayload)).then((response) => {
        const { result } = response.payload;
        setLoadingState(false);
        setPagination({
          pageErrors: result.errors,
          currentPage: pageNo
        });
      });
    },
    [dispatch, searchTypeId, setLoadingState, setPagination, stopAutoRefresh]
  );
};
const InvestigationsList = ({
  data,
  config,
  onConfigChange,
  setLoadingState
}) => {
  var _a;
  const [{ currentPage, pageErrors }, setPagination] = useState({
    pageErrors: [],
    currentPage: PAGINATION.INITIAL_PAGE
  });
  const onRenderComplete = useContext(RenderCompletionCallback);
  useResetPaginationOnSearchExecution(setPagination, currentPage);
  const handlePageChange = useHandlePageChange(data.id, setLoadingState, setPagination);
  const refreshCurrentPage = useCallback(() => handlePageChange(currentPage), [currentPage, handlePageChange]);
  const onSortChange = useCallback(
    (newSort) => {
      const newConfig = config.toBuilder().sort(newSort).build();
      return onConfigChange(newConfig);
    },
    [config, onConfigChange]
  );
  useEffect(() => {
    onRenderComplete();
  }, [onRenderComplete]);
  return /* @__PURE__ */ React.createElement(Container, null, /* @__PURE__ */ React.createElement(
    PaginatedList,
    {
      onChange: handlePageChange,
      useQueryParameter: false,
      activePage: currentPage,
      pageSize: PAGINATION.PER_PAGE,
      showPageSizeSelect: false,
      totalItems: (_a = data.totalResults) != null ? _a : 0
    },
    !(pageErrors == null ? void 0 : pageErrors.length) ? /* @__PURE__ */ React.createElement(
      InvestigationsTable,
      {
        config,
        onArchive: refreshCurrentPage,
        onDelete: refreshCurrentPage,
        setLoadingState,
        onSortChange,
        investigations: data.investigations
      }
    ) : /* @__PURE__ */ React.createElement(ErrorWidget, { errors: pageErrors })
  ));
};
export default InvestigationsList;
